<div class="modal-overlay">
  <div class="modal-container">
    <div class="modal-header">
      <button class="close-button" (click)="cancel()">&times;</button>
      <div class="image-container">
        <img src="/assets/images/Illustrations.svg" alt="Illustration" />
      </div>
    </div>
    <div class="modal-content">
      
      <h2>This account is active on another device</h2>
      <p>
        You’re currently logged in on another device. Do you want to end that
        session and continue here?
      </p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
      <button class="btn btn-primary" (click)="proceed()">Log In</button>
    </div>
  </div>
</div>
